import { render, staticRenderFns } from "./BillingDetailsForm.vue?vue&type=template&id=6e72bece&"
import script from "./BillingDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./BillingDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports